import React, { useState, useCallback, memo } from "react";
import { GoogleMap, useJsApiLoader, Circle } from "@react-google-maps/api"

const MyMapComponent = (props) => {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: googleMapsApiKey
    })

    const [map, setMap] = useState(null)

    const center = {
        lat: props.coordinates.latitude,
        lng: props.coordinates.longitude
    };

    const onLoad = useCallback(function callback(map) {
        // This is just an example of getting and using the map instance!!! don't just blindly copy!
        const bounds = new window.google.maps.LatLngBounds(center);
        map.fitBounds(bounds);
        setMap(map)
      }, [])

    const onUnmount = useCallback(function callback(map) {
        setMap(null)
    }, [])

    const containerStyle = {
        width: '100%',
        height: '400px'
    };

    return isLoaded ? (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            onLoad={onLoad}
            zoom={12}
            onUnmount={onUnmount}
            options={{
                zoom:12
            }}
        >
            {props.isMarkerShown && (
                <Circle
                    center={{ lat: center.lat, lng: center.lng }}
                    radius={2500}
                    onClick={props.onMarkerClick}
                    options={{strokeOpacity: 0}}
                />
            )}
        <></>
        </GoogleMap>
    ) : <></>
}

export default memo(MyMapComponent)
